import { Plus, Minus, Check } from 'lucide-react';
import type { ResumeDiff as ResumeDiffT } from '@/services/types';

export function ResumeDiff({ diff }: { diff: ResumeDiffT }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-2 text-center text-xs">
        <DiffStat label="unchanged" count={diff.unchanged.length} tone="gray" icon={<Check className="h-3 w-3" />} />
        <DiffStat label="added" count={diff.added.length} tone="green" icon={<Plus className="h-3 w-3" />} />
        <DiffStat label="removed" count={diff.removed.length} tone="red" icon={<Minus className="h-3 w-3" />} />
      </div>

      <div>
        <h4 className="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
          Bullets added for this role
        </h4>
        <ul className="space-y-1.5">
          {diff.added.length === 0 && (
            <li className="text-xs text-gray-400">
              None — this application used the master resume unchanged.
            </li>
          )}
          {diff.added.map((e, i) => (
            <li key={i} className="rounded-md bg-green-50 px-3 py-1.5 text-sm text-green-900">
              <span className="mr-1.5 text-green-600">+</span>
              {e.text}
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
          Master bullets dropped
        </h4>
        <ul className="space-y-1.5">
          {diff.removed.length === 0 && (
            <li className="text-xs text-gray-400">None dropped.</li>
          )}
          {diff.removed.map((e, i) => (
            <li key={i} className="rounded-md bg-red-50 px-3 py-1.5 text-sm text-red-900">
              <span className="mr-1.5 text-red-600">−</span>
              {e.text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function DiffStat({
  label,
  count,
  tone,
  icon,
}: {
  label: string;
  count: number;
  tone: 'gray' | 'green' | 'red';
  icon: React.ReactNode;
}) {
  const cls = {
    gray: 'bg-gray-100 text-gray-700',
    green: 'bg-green-100 text-green-800',
    red: 'bg-red-100 text-red-800',
  }[tone];
  return (
    <div className={`rounded-md px-3 py-2 ${cls}`}>
      <div className="flex items-center justify-center gap-1 font-semibold tabular-nums">
        {icon}
        {count}
      </div>
      <div>{label}</div>
    </div>
  );
}
